import React__default from 'react';
import { useCmsData, ProductReimbursableLogoView } from '@grandvisionhq/fun-products';
import { getActiveVariant } from '../../../../helpers.js';
import { useProductDetailContext } from '../../../Context/ProductDetailContext.js';

const ProductReimbursableLogoContainer = ({ className  })=>{
    const { product , activeSku , isReimbursable  } = useProductDetailContext();
    const { reimbursableLogos  } = useCmsData();
    const activeVariant = getActiveVariant(product, activeSku);
    if (!activeVariant.isInsuranceReimbursable) return null;
    return /*#__PURE__*/ React__default.createElement(ProductReimbursableLogoView, {
        className: className,
        logos: reimbursableLogos,
        variant: isReimbursable ? 'alternative' : 'default'
    });
};

export { ProductReimbursableLogoContainer };
//# sourceMappingURL=ProductReimbursableLogoContainer.js.map
